/**
 * Privacy settings — toggle visibility on leaderboard, profile, and activity.
 * Persists to AsyncStorage locally; can be synced to Supabase profile.
 */

import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = 'duel_privacy_settings';

export interface PrivacySettings {
  showOnLeaderboard: boolean;
  publicProfile: boolean;
  showActivityToOthers: boolean;
}

const DEFAULTS: PrivacySettings = {
  showOnLeaderboard: true,
  publicProfile: true,
  showActivityToOthers: true,
};

export async function getPrivacySettings(): Promise<PrivacySettings> {
  try {
    const raw = await AsyncStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...DEFAULTS, ...parsed };
    }
  } catch { /* fallback */ }
  return { ...DEFAULTS };
}

export async function setPrivacySettings(updates: Partial<PrivacySettings>): Promise<PrivacySettings> {
  const current = await getPrivacySettings();
  const merged = { ...current, ...updates };
  await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  return merged;
}
